import rest from '@modules/rest'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { ADDITIONAL_AREA } from '@convenia/employee-organisms/SystemFields/AdditionalFields/content/consts'
import { mapCustomFields } from '@convenia/employee-organisms/SystemFields/AdditionalFields/content/mappers/additionalFields'

export const getAdditionalInfo = async (getters) => {
  const employeeId = getters.getEmployeeUuid
  const companyId = getters.getCompanyUuid

  try {
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/custom-field-values/additional/admission`

    const { data } = await rest.get(url) || {}

    return [ null, data ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateAdditionalInfo = async (data, params) => {
  try {
    const { employeeId, companyId, schema, sectionId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/sections/${sectionId}/custom-field-values/admission`
    const body = {
      custom_fields: mapCustomFieldValues({
        data,
        schema,
        sectionId,
      })
    }

    await rest.put(url, { body })

    return [ null ]
  } catch (err) {
    return [ err ]
  }
}

export const getSystemFields = async ({ employeeId, companyId }) => {
  try {
    const url = `/companies/proxy/companies/${companyId}/employees/${employeeId}/fields/admission`
    const params = { params: { area: ADDITIONAL_AREA.LABEL } }

    const { data } = await rest.get(url, params) || {}
    const [ section ] = data.sections || []

    const sectionId = section?.id
    const customFields = mapCustomFields(data?.sections || [])

    return [ null, { sectionId, customFields } ]
  } catch (err) {
    return [ err, null ]
  }
}
